import { render, staticRenderFns } from "./StepperSelfscanning.vue?vue&type=template&id=567cf116&scoped=true"
import script from "./StepperSelfscanning.vue?vue&type=script&lang=js"
export * from "./StepperSelfscanning.vue?vue&type=script&lang=js"
import style0 from "./StepperSelfscanning.vue?vue&type=style&index=0&id=567cf116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567cf116",
  null
  
)

export default component.exports